import { useEffect, useState } from 'react';
import { Col, Row, Spinner } from 'react-bootstrap';
import './_SubscriberDataFeed.scss';
import { useIsAuthenticated, useMsal, useAccount } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { configureMap } from '../../../../../config/AppConfig';
import { LoginType } from '../../../template/types/IHeader';
import { litrals } from '../../../../../constants/Litrals';
import Button from '../../../../ntisui/Atoms/Buttons';

import { ButtonVariant } from '../../../template/types/IHeader';
import { useHistory } from 'react-router-dom';
import { faPlusSquare } from '@fortawesome/free-solid-svg-icons';
import SubscribedFeedsContainer from '../../molecules/SubscribedFeedsContainer';
import {
  deleteCookies,
  getCookies,
} from '../../../../../utils/LocalStorageManager';
import {
  breadcrumbsLinks,
  cookiesConstants,
} from '../../../../../constants/Constants';
import { historyRoutes } from '../../../../../constants/HistoryRoutes';
import Breadcrumbs from '../../../../ntisui/Atoms/Breadcrumb';
import { getData } from '../../../../../api/ApiCommunication';

const SubscriberDataFeed = () => {
  const history = useHistory();
  const { instance, inProgress, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const [msalData, setMsalData] = useState<any>({});
  const account = useAccount(accounts[0] || {});
  const userId = (account && account.localAccountId) || '';
  const [isApproved, setIsApproved] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    configureMap().then((result: any) => setMsalData(result));
  }, []);

  useEffect(() => {
    const beforeUnloadListener = () => {
      getCookies(cookiesConstants.ntisWebCookieKey) !=
        cookiesConstants.ntisAcceptWebCookieValue &&
        deleteCookies(`${cookiesConstants.ntisAddDataFeedCookieKey}-${userId}`);
    };
    window.addEventListener('beforeunload', beforeUnloadListener);
    async function fetchGetSubscriberData() {
      await getData('approveSubscriber', '')
        .then((res) => {
          setIsApproved(res.data.data.isApproved);
          setIsLoading(false);
        })
        .catch(() => setIsLoading(false));
    }
    isAuthenticated ? fetchGetSubscriberData() : setIsLoading(false);
    return () => {
      window.removeEventListener('beforeunload', beforeUnloadListener);
    };
  }, []);

  /**
   * Handle SignIn, SignUp and Logout
   * @param loginType
   */
  const handleLogin = (loginType: string) => {
    if (
      loginType === LoginType.Signin &&
      inProgress === InteractionStatus.None &&
      !isAuthenticated
    ) {
      const loginRequest = {
        scopes: [msalData.B2C_Scope],
      };
      instance.loginRedirect(loginRequest).catch(() => {
        return;
      });
    } else if (
      loginType === LoginType.Signup &&
      inProgress === InteractionStatus.None &&
      !isAuthenticated
    ) {
      const signUpRequest = {
        scopes: [msalData.B2C_Scope],
        authority: msalData.B2C_SignUp,
      };
      instance.loginRedirect(signUpRequest).catch(() => {
        return;
      });
    }
  };

  const handleAddDataFeed = () => {
    if (
      getCookies(`${cookiesConstants.ntisAddDataFeedCookieKey}-${userId}`) !=
      cookiesConstants.ntisAddDataFeedCookieValue
    )
      history.push(historyRoutes.dataFeedPolicy);
    else history.push(historyRoutes.availableDataFeed);
  };

  return (
    <>
      <div className="breadcrum-padding">
        <Breadcrumbs links={breadcrumbsLinks.NTISDataFeeds} />
      </div>
      <Row className="subscriberdata-feed-container">
        <Col className="card-container-new container-left">
          <h4 className="section-heading">{litrals.aboutSubscriberDataFeed}</h4>
          <div className="content-paragraph">
            <p className="section-paragraph">
              {litrals.aboutSubscriberDataFeedContentOne}
            </p>
          </div>
        </Col>
        <Col className="card-container-new container-right">
          <div className="section-heading">
            <h4>{litrals.currentSubscriptions}</h4>
            {isApproved && isAuthenticated && (
              <Button
                className="add-datafeed-button"
                onClick={handleAddDataFeed}
                variant={ButtonVariant.Primary}
                label={litrals.addDataFeed}
                icon={faPlusSquare}
              />
            )}
          </div>
          {!isAuthenticated && (
            <div className="content-paragraph">
              <p className="section-paragraph">
                {litrals.subscribeToDataFeed}{' '}
                <a
                  tabIndex={0}
                  onClick={(e) => {
                    e.preventDefault();
                    handleLogin(LoginType.Signin);
                  }}
                  href="javascript: void(0)"
                >
                  {litrals.login}
                </a>{' '}
                {litrals.dontHaveAccount}
                <a
                  tabIndex={0}
                  onClick={(e) => {
                    e.preventDefault();
                    handleLogin(LoginType.Signup);
                  }}
                  href="javascript: void(0)"
                >
                  {litrals.register}
                </a>
              </p>
            </div>
          )}
          {!isApproved && !isLoading && isAuthenticated && (
            <p className="content-paragraph mt-4">
              Waiting for operator approval!
            </p>
          )}
          {isLoading && (
            <div className="subscribed-datafeed-loader">
              <Spinner animation="border" role="status" />
            </div>
          )}
          {isAuthenticated && isApproved && <SubscribedFeedsContainer />}
        </Col>
      </Row>
    </>
  );
};
export default SubscriberDataFeed;
